import io from "socket.io-client"; 
import React from "react";
export const socket = io('https://qc2.hpcfuelrite.com', { transports: ['websocket'] });
export const SocketContext = React.createContext();
